import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import {NavLink} from 'react-router-dom';
const ITEM_HEIGHT = 48;

export default function LongMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon style={{ color: 'white' }} />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                    },
                }}
            >
            <NavLink activeClassName="text-primary" style={{color : 'gray'}} exact  to="/">
            <MenuItem onClick={handleClose}>
                Home
            </MenuItem>
            </NavLink>
            <NavLink activeClassName="text-primary" style={{color : 'gray'}} to="/services" exact >
            <MenuItem onClick={handleClose}>
                Our Services
            </MenuItem>
            </NavLink>
            <NavLink activeClassName="text-primary" style={{color : 'gray'}} to="/register" exact>
            <MenuItem onClick={handleClose}>
                Register
            </MenuItem>
            </NavLink>
            
      </Menu>
        </div>
    );
}